export default "__VITE_ASSET__BNSFD$0t__"